
export const baseUrl= 'https://sebastianpanotto.com/admin/api/index.php'
export const baseUrlVideos='https://sebastianpanotto.com/admin/videos'
export const baseUrlClientes='https://sebastianpanotto.com/admin/clientes'
export const baseUrlBlog='https://sebastianpanotto.com/admin/blog'
